// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:8593b8d7-9807-4a0b-a005-2ca2da993509",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_MiB9M2KL0",
    "aws_user_pools_web_client_id": "1bj57pfqg273ssuikvbqvstd3m",
    "aws_appsync_graphqlEndpoint": "https://vtjqgdqzkzbphcwzowrkv5chbq.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_content_delivery_bucket": "roots-prod",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "http://roots-prod.s3-website-eu-west-1.amazonaws.com"
};


export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js